import styles from "./FormPageLayout.module.scss";
import { Outlet } from "react-router-dom";


export const FormPageLayout = () => {
  return (
    <div className={styles.wrapper}>
      <section className={styles.image}></section>
      <section className={styles.content}>
        <Outlet />
      </section>
    </div>
  );
};
